import { useEffect } from 'react'
import AvatarAgent from '../BlocAgent/AvatarAgent'
import { Card, CardContent, CardHeader, Link as LinkMUI, Typography } from '@mui/material'
import { getAdresseUnite, getCivilite } from '../Utils/fonctions'
import { IBalf } from '../../lib/interface/agent'
import { useFetchContext } from '../../hook/UseFetchContext'
import { GET_UNITE_AGENT_SELECTED_SUCCESS } from '../../lib/typeKey'
import { InseeTheme } from '../../theme/theme'
import ChampBlocPhoto from './ChampBlocPhoto'
import { getLanguePourLesUnitesPasEnFrancaisBlocPhoto } from '../BlocUnite/langUnite'

const styles = {
  root: {
    marginTop: '1em',
    padding: 0,
    height: '75vh',
    backgroundColor: 'canvas.main',
    overflow: 'auto',
    overflowY: 'scroll'
  },
  details: { display: 'flex', flexDirection: 'column' },
  content: { flex: '1 0 auto' },
  avatar: {
    width: 100,
    height: 100,
    marginRight: 0,
    color: 'primary.main',
    backgroundColor: 'secondary.main',
    fontSize: '3em'
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: InseeTheme.spacing(1),
    paddingBottom: InseeTheme.spacing(1)
  }
}

export default function BlocPhoto() {
  const { state, fetchGetData } = useFetchContext()
  const agent = state.agentState.agentSelected
  const uniteAgent = state.agentState.uniteAgentSelected

  useEffect(() => {
    if (agent?.affectation) {
      fetchGetData(`unite/${agent.affectation.unite}`, GET_UNITE_AGENT_SELECTED_SUCCESS)
    }
  }, [agent])

  if (!uniteAgent) {
    return <></>
  }

  return (
    agent && (
      <>
        <Typography
          component="h2"
          variant="subtitle1"
          color="secondary"
          sx={{ textAlign: 'center', my: -1 }}
        >
          Fiche de l'agent
        </Typography>
        <Card
          sx={styles.root}
          data-cy={`fiche-agent-${agent.identifiantsAgent.idep}`}
        >
          <CardHeader
            avatar={
              <AvatarAgent
                sx={styles.avatar}
                agent={agent}
              />
            }
            title={
              <ChampBlocPhoto
                variant="h6"
                component="h3"
                color="inherit"
                noDefaultSx
                data-cy="civilite"
              >
                {getCivilite(agent)}
              </ChampBlocPhoto>
            }
            subheader={
              <ChampBlocPhoto data-cy="idep">
                <strong>Idep : </strong> {agent.identifiantsAgent.idep}
              </ChampBlocPhoto>
            }
          />
          <CardContent
            sx={styles.content}
            style={{ paddingBottom: 0 }}
          >
            <ChampBlocPhoto data-cy="grade">
              <strong>Grade : </strong>
              {agent.carriere.grade.libelle}
            </ChampBlocPhoto>

            <ChampBlocPhoto data-cy="unite">
              {agent.affectation.estResponsable ? (
                <strong>{"Est responsable de l'unité : "}</strong>
              ) : (
                <strong>{"Est agent de l'unité : "}</strong>
              )}
              <span {...getLanguePourLesUnitesPasEnFrancaisBlocPhoto(uniteAgent)}>{uniteAgent.libelleLong}</span>
            </ChampBlocPhoto>

            <ChampBlocPhoto data-cy="timbre">
              <strong>Timbre : </strong>
              {uniteAgent.timbre}
            </ChampBlocPhoto>

            <ChampBlocPhoto data-cy="fonction">
              <strong>Fonction : </strong>
              {agent.affectation.fonction?.libelle}
            </ChampBlocPhoto>
            {agent.attributions.length !== 0 && (
              <ChampBlocPhoto data-cy="agent-attributions">
                <strong>Attributions : </strong>
                {agent.attributions.map((attribution) => attribution.libelle).join('; ')}
              </ChampBlocPhoto>
            )}
            <ChampBlocPhoto data-cy="bureau">
              <strong>Bureau : </strong>
              {agent.coordonnees?.bureau}
            </ChampBlocPhoto>

            <ChampBlocPhoto data-cy="telephone">
              <strong>Téléphone : </strong>
              {agent.coordonnees?.telephoneProfessionnel}
            </ChampBlocPhoto>

            <ChampBlocPhoto data-cy="portable">
              <strong>Portable professionnel : </strong>
              {agent.coordonnees?.portableProfessionnel}
            </ChampBlocPhoto>

            <ChampBlocPhoto data-cy="mail">
              <strong>Mail : </strong>
              {agent.coordonnees?.email && (
                <LinkMUI href={'mailto:' + agent.coordonnees.email}>
                  <ChampBlocPhoto
                    component="span"
                    sx={{ textDecoration: 'underline' }}
                    tabIndex={undefined}
                  >
                    {agent.coordonnees.email}
                  </ChampBlocPhoto>
                </LinkMUI>
              )}
            </ChampBlocPhoto>

            {agent?.balf?.length > 0 ? (
              <div>
                <ChampBlocPhoto data-cy="balf">
                  <strong>Boîtes fonctionnelles de l'agent :</strong>
                </ChampBlocPhoto>
                <ul style={{ marginTop: -6, marginBottom: 3 }}>
                  {agent.balf?.map((balf: IBalf, index) => (
                    <li key={balf.nom}>
                      <LinkMUI href={'mailto:' + balf.adresse}>
                        <ChampBlocPhoto
                          component="span"
                          sx={{ textDecoration: 'underline' }}
                          data-cy={`balf-${index}`}
                          tabIndex={undefined}
                        >
                          {balf.nom}
                        </ChampBlocPhoto>
                      </LinkMUI>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div />
            )}

            <ChampBlocPhoto
              component="span"
              data-cy="adresse"
            >
              <strong>Adresse de l'unité : </strong>
              {getAdresseUnite(uniteAgent).map((value) => (
                <p
                  key={value}
                  style={{ margin: 0 }}
                >
                  {value}
                </p>
              ))}
            </ChampBlocPhoto>
          </CardContent>
        </Card>
      </>
    )
  )
}
